import { EEndpointFragment } from 'app/store/auth/model/enums';

export const NO_RETRY_ENDPOINTS = [
  EEndpointFragment.Login,
  EEndpointFragment.PasswordReset,
  EEndpointFragment.Refresh,
];
